import * as React from 'react';
import IconButton from '../common/IconButton';
import { ToolbarDirection } from '../../actions/UIModeAction';

interface HeaderToolbarPositionChangeButtonProps {
  readonly toolbarDirection: ToolbarDirection;
  readonly style?: React.CSSProperties;
  readonly svgStyle?: React.CSSProperties;
  readonly onClick?: () => void;
}

const HeaderToolbarPositionChangeButton: React.SFC<
  HeaderToolbarPositionChangeButtonProps
> = React.memo((props) => {
  const { toolbarDirection, style, svgStyle, onClick } = props;

  const rotation: React.CSSProperties | null = toolbarDirection === ToolbarDirection.VerticalRight
    ? { transform: 'rotateZ(180deg)' }
    : null;

  return (
    <IconButton
      title="ツールバー移動"
      style={{ ...style, ...rotation }}
      svgStyle={svgStyle}
      margin={false}
      imagePath="images/toolbar/toolbar_collapse"
      onClick={onClick} />
  );
});

export default HeaderToolbarPositionChangeButton;
